// 签订合同模版
import http from "@/promise/http"
const CONTROLLER_NAME = "/contractTemplate/"

export const GetFindAll = () => {
    return http.get(CONTROLLER_NAME.concat("findAll"));
}